import { render, staticRenderFns } from "./urlButton.vue?vue&type=template&id=51470cf6&scoped=true&"
import script from "./urlButton.vue?vue&type=script&lang=js&"
export * from "./urlButton.vue?vue&type=script&lang=js&"
import style0 from "./urlButton.vue?vue&type=style&index=0&id=51470cf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51470cf6",
  null
  
)

export default component.exports